import easyCheckApi, { easyCheckRequest } from '../api/config';

// Bank Configuration Backup — export / validate / import.
// All endpoints are gated by the enableBankBackup company preference (403 FEATURE_DISABLED when off).

const unwrap = (response) => {
  if (!response.success) {
    throw new Error(response.message || 'Request failed');
  }
  let data = response.data;
  if (data && data.data) data = data.data;
  return data;
};

export const bankBackupService = {
  /**
   * Fetch the full bank + template configuration document
   * ({ schemaVersion, exportedAt, companyCode, banks: [...] }).
   */
  exportConfig: async () => {
    const response = await easyCheckRequest(() => easyCheckApi.get('/bank-backup/export'));
    return unwrap(response);
  },

  /** Trigger a browser download of an export document as a JSON file. */
  downloadConfigFile: (document_) => {
    const fileName = `easycheck-bank-config-${new Date().toISOString().slice(0, 10)}.json`;
    const blob = new Blob([JSON.stringify(document_, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(url);
    return fileName;
  },

  /**
   * Dry-run validation of an uploaded config document.
   * Returns rows with status NEW | EXISTS_SAME_COMPANY | CONFLICT_OTHER_COMPANY | CONFLICT_INACTIVE | INVALID.
   */
  validateImport: async (configDocument) => {
    const response = await easyCheckRequest(() =>
      easyCheckApi.post('/bank-backup/validate', configDocument)
    );
    return unwrap(response);
  },

  /**
   * Transactional apply. banks entries carry mode: 'create' | 'overwrite-template' | 'skip'.
   * Returns per-row results with action CREATED | TEMPLATE_UPDATED | SKIPPED | FAILED.
   */
  applyImport: async (importRequest) => {
    const response = await easyCheckRequest(() =>
      easyCheckApi.post('/bank-backup/import', importRequest)
    );
    return unwrap(response);
  },
};

export default bankBackupService;
